import React, { useEffect, useRef } from 'react';

interface pageTitleTypes {
  pageTitle: string | null;
}

/* Maps page title keywords to remix-icon class names */
const getTitleIcon = (title: string | null): string => {
  if (!title) return 'ri-layout-grid-line';
  const t = title.toLowerCase();
  if (t.includes('dashboard'))        return 'ri-dashboard-line';
  if (t.includes('volunteer'))        return 'ri-user-heart-line';
  if (t.includes('study'))           return 'ri-microscope-line';
  if (t.includes('crf'))             return 'ri-file-list-3-line';
  if (t.includes('template'))        return 'ri-layout-2-line';
  if (t.includes('codelist'))        return 'ri-code-s-slash-line';
  if (t.includes('checklist'))       return 'ri-checkbox-multiple-line';
  if (t.includes('workflow'))        return 'ri-git-branch-line';
  if (t.includes('role'))            return 'ri-shield-user-line';
  if (t.includes('user'))            return 'ri-team-line';
  if (t.includes('design'))         return 'ri-palette-line';
  if (t.includes('adverse'))        return 'ri-alert-line';
  if (t.includes('ip') || t.includes('inventory')) return 'ri-flask-line';
  if (t.includes('dispensing'))     return 'ri-medicine-bottle-line';
  if (t.includes('aliquot'))        return 'ri-test-tube-line';
  if (t.includes('sponsor'))        return 'ri-building-2-line';
  if (t.includes('period'))         return 'ri-time-line';
  if (t.includes('transfer'))       return 'ri-exchange-line';
  if (t.includes('disposal') || t.includes('destruction')) return 'ri-delete-bin-line';
  if (t.includes('retention'))      return 'ri-archive-line';
  if (t.includes('print'))         return 'ri-printer-line';
  if (t.includes('scan'))          return 'ri-qr-scan-2-line';
  if (t.includes('accession'))     return 'ri-barcode-line';
  if (t.includes('reconcil'))      return 'ri-equalizer-line';
  if (t.includes('report'))        return 'ri-bar-chart-2-line';
  if (t.includes('audit'))         return 'ri-shield-check-line';
  if (t.includes('training'))      return 'ri-graduation-cap-line';
  if (t.includes('company'))       return 'ri-building-line';
  if (t.includes('setting'))       return 'ri-settings-3-line';
  if (t.includes('password'))      return 'ri-lock-line';
  if (t.includes('session'))       return 'ri-time-line';
  if (t.includes('document'))      return 'ri-folder-open-line';
  if (t.includes('returns'))       return 'ri-arrow-go-back-line';
  if (t.includes('stock'))         return 'ri-stock-line';
  return 'ri-pages-line';
};

const PageTitle: React.FC<pageTitleTypes> = ({ pageTitle }) => {
  const titleRef = useRef<HTMLDivElement>(null);

  /* Re-trigger the fade-in animation whenever the title changes */
  useEffect(() => {
    const el = titleRef.current;
    if (!el) return;
    el.classList.remove('header-page-title--animated');
    // force reflow
    void el.offsetWidth;
    el.classList.add('header-page-title--animated');
  }, [pageTitle]);

  const icon = getTitleIcon(pageTitle);

  return (
    <div className="header-page-title header-page-title--animated" ref={titleRef}>
      {/* Icon badge */}
      <div className="page-title-icon">
        <i className={icon} />
      </div>

      {/* Text */}
      <div className="page-title-text">
        <h5 className="mb-sm-0">{pageTitle}</h5>
      </div>
    </div>
  );
};

export default PageTitle;